import { HomeTabType, HomeViewType } from '@/core/presenter/viewModel/viewTypes';
import PropertyArea from './PropertyArea';
import ActivityArea from './ActivityArea';
import clsx from 'clsx';
import * as ViewModel from '@/core/presenter/viewModel';

interface IProps {
  activities: ViewModel.IResponseActivity[];
  isNotActivities: boolean;
  trxAsset?: ViewModel.IAsset;
  tokenAsset?: ViewModel.IAsset;
  trxBalance: string;
  tokenBalance: string;
  trxKrw: string;
  tokenKrw: string;
  activeTab: ViewModel.HomeTabType;
  trxPrice: number;
  tokenPrice: number;
  onClickActiveTab: (tab: ViewModel.HomeTabType) => void;
  onClickViewType: (viewType: HomeViewType) => void;
  onClickPrevTransactionBtn: () => void;
}

const HomeTab = ({
  activities,
  isNotActivities,
  trxAsset,
  tokenAsset,
  trxBalance,
  tokenBalance,
  trxKrw,
  tokenKrw,
  activeTab,
  trxPrice,
  tokenPrice,
  onClickActiveTab,
  onClickViewType,
  onClickPrevTransactionBtn,
}: IProps): JSX.Element => {
  return (
    <>
      <div className="tab-menu" id="tab">
        <button
          type="button"
          className={clsx('tab-btn text-base font-semibold', { 'active': activeTab === HomeTabType.ASSETS })}
          // className="tab-btn active text-base font-semibold"
          onClick={() => onClickActiveTab(HomeTabType.ASSETS)}
        >
          자산
        </button>
        <button
          type="button"
          className={clsx('tab-btn text-base font-semibold', { 'active': activeTab === HomeTabType.ACTIVITIES })}
          onClick={() => onClickActiveTab(HomeTabType.ACTIVITIES)}
        >
          활동
        </button>
      </div>
      {activeTab === HomeTabType.ASSETS && (
        <PropertyArea
          trxAsset={trxAsset}
          tokenAsset={tokenAsset}
          trxBalance={trxBalance}
          tokenBalance={tokenBalance}
          trxKrw={trxKrw}
          tokenKrw={tokenKrw}
          trxPrice={trxPrice}
          tokenPrice={tokenPrice}
          onClickViewType={onClickViewType}
        />
      )}
      {activeTab === HomeTabType.ACTIVITIES && (
        <ActivityArea
          activeTab={activeTab}
          activities={activities}
          isNotActivities={isNotActivities}
          onClickPrevTransactionBtn={onClickPrevTransactionBtn}
        />
      )}
    </>
  );
};

export default HomeTab;
